import { CartProductWithQuantity } from "../../ts/interfaces"
import { klaviyoTrackBehavior } from "../../utils/klaviyo"
import { sendPixelEvent, PixelEventType } from "../../utils/pixel"
import { getCartProduct } from "../../utils/stripejs"
import { useCheckoutState } from "../state"

const usePixelEvent = (eventName: PixelEventType) => {
  const checkoutState = useCheckoutState()
  const { cartItems, currency, total } = checkoutState

  const executeSendPixelEvent = async (input: {
    email?: string
    firstName?: string
    lastName?: string
    phone?: string
    country?: string
    confirmationCode?: string
  }) => {
    if (eventName === "Purchase" && total === 0) {
      console.log("Purchase event not sent because total is 0")
      return
    }

    const cartProducts: CartProductWithQuantity[] = []

    cartItems.forEach(cartItem => {
      const product = getCartProduct(cartItem.productId)
      if (product && cartItem.quantity) {
        cartProducts.push({
          ...product,
          quantity: cartItem.quantity,
        })
      }
    })
    const eventObject = {
      items: cartProducts,
      currency: currency,
      total,
      ...(input.confirmationCode
        ? { confirmationCode: input.confirmationCode }
        : {}),
    }

    await sendPixelEvent(eventName, eventObject, input)
    if (eventName === "InitiateCheckout") {
      setTimeout(() => {
        //use a small delay to give time for queue to process new accounts
        klaviyoTrackBehavior("Started Checkout", {
          content_type: "product",
          content: [
            ...cartProducts.map(product => ({
              id: product?.id,
              name: product?.name,
              quantity: product?.quantity,
            })),
          ],
          value: parseFloat((total / 100.0).toFixed(2)),
          currency: currency,
        })
      }, 1000)
    }
  }

  return [executeSendPixelEvent]
}

export default usePixelEvent
